var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _rect12, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2.5,
    width: 28,
    height: 23,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 5.5,
    width: 22,
    height: 2,
    rx: 1,
    fill: "white",
    stroke: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 9.5,
    width: 13,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 19,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15.5,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 15.5,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18.5,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 18.5,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 21.5,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 21.5,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 9.5,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4219 17.9585C29.4435 17.6993 29.6601 17.5 29.9201 17.5H38.0799C38.3399 17.5 38.5565 17.6993 38.5781 17.9585L39.354 27.2683C39.3864 27.657 38.981 27.9315 38.6321 27.757L34.6708 25.7764C34.2485 25.5652 33.7515 25.5652 33.3292 25.7764L29.3679 27.757C29.019 27.9315 28.6136 27.657 28.646 27.2683L29.4219 17.9585Z",
    fill: "white",
    stroke: "#333333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 11.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8018 9.79688H10.1982V19.7637C10.1982 20.2822 9.89062 20.5107 9.1875 20.5107C9.0293 20.5107 8.87988 20.502 8.77441 20.4844V22.9893C8.98535 23.0156 9.5127 23.042 9.88184 23.042C12.3516 23.042 13.8018 21.8906 13.8018 19.9219V9.79688ZM12 9.26074C13.0195 9.26074 13.793 8.52246 13.793 7.55566C13.793 6.58887 13.0195 5.85059 12 5.85059C10.9805 5.85059 10.207 6.58887 10.207 7.55566C10.207 8.52246 10.9805 9.26074 12 9.26074Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicence);
export default __webpack_public_path__ + "static/media/licence.8515be0c311a6dcb9cbeb037de8fe33c.svg";
export { ForwardRef as ReactComponent };